module.exports = __webpack_public_path__ + "static/media/coverteye-4.9f90e43e.jpg";